<template>
  <div class="container py-4 py-lg-5 my-lg-5 px-4 px-sm-0">
    <div class="col-sm-12 ml-auto">
      <div class="card p-4">
        <h1 class="text-center fw-400 mb-4 d-xs-block">
          Usuwanie konta
        </h1>

        <p>Potwierdź usunięcie konta.</p>

        <p>
          Przypominamy, że usunięcie konta spowoduje utratę wszystkich powiązanych z nim danych.
        </p>

        <w-button class="btn btn-danger" icon="fa fa-user-times" text="Usuń konto" @click="confirm" />
      </div>
    </div>
  </div>
</template>

<script>
import { Successes } from '@/enums/successes.enum';
import { notificationsMixin } from '@/mixins/notifications';
import { authResource } from '@/resources/auth.resource';
import { serverError } from '@/utils/serverError';

// @vuese
// Pożegnanie z systemem
// @group startRoute
export default {
  mixins: [notificationsMixin],
  data() {
    return {
      title: process.env.VUE_APP_TITLE
    };
  },
  methods: {
    // @vuese
    // Usunięcie konta
    deleteAccount() {
      const token = this.$route.params.token;
      authResource
        .confirmDelete(token)
        .then(() => {
          this.notifySuccess(Successes.ACCOUNT_DELETED);
          this.$router.push({ name: 'login' });
        })
        .catch(error => {
          this.notifyError(serverError(error));
        });
    },
    // @vuese
    // Potwierdzenie usunięcia
    confirm() {
      this.$store.commit('showConfirm', {
        title: 'Uwaga',
        description: 'Potwierdź chęć usunięcia konta',
        submitButton: 'Potwierdzam',
        showCloseButton: false,
        onSuccess: () => this.deleteAccount()
      });
    }
  }
};
</script>
